import { DialogActions, DialogContent, Grid, Link } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { XsBaseDialog, XsButton, XsCheckbox } from '../../../global/ui';
import ConsentDialogStore from './ConsentDialogStore';

interface IConsentForm {
  consent: boolean;
}

interface Props {
  onConfirm: () => void;
}

function ConsentDialog({ onConfirm }: Props) {
  const { t } = useTranslation();

  const { control, handleSubmit, watch, reset } = useForm<IConsentForm>({
    defaultValues: { consent: false }
  });

  const consentValue = watch('consent');

  const handleClose = () => {
    reset();
    ConsentDialogStore.close();
  };

  const onSubmit = handleSubmit(() => {
    reset();
    ConsentDialogStore.close();
    onConfirm();
  });

  return (
    <XsBaseDialog
      open={ConsentDialogStore.isOpen}
      onClose={handleClose}
      title={t('request_form.consent_dialog_title')}
      maxWidth='md'
      fullWidth
    >
      <DialogContent>
        <form id='consent-form' onSubmit={onSubmit}>
          <Grid container direction='column' spacing={2} className='pt-2'>
            <Grid item>
              {t('request_form.consent_personal_data_text')}{' '}
              <Link
                className='pointer'
                underline='always'
                onClick={() => window.open('https://www.siea.sk/o-siea/ochrana-osobnych-udajov/', '_blank')}
              >
                https://www.siea.sk/o-siea/ochrana-osobnych-udajov/
              </Link>
            </Grid>
            <Grid item>
              <Controller
                name='consent'
                control={control}
                render={({ field }) => (
                  <XsCheckbox controllerProps={field} label={t('request_form.consent_checkbox_label')} />
                )}
              />
            </Grid>
            <Grid item>
              <span style={{ color: 'red' }}>{t('request_form.consent_required_warning')}</span>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent='space-between' style={{ padding: '0 8px 8px' }}>
          <Grid item>
            <XsButton label='global.cancel' variant='outlined' onClick={handleClose} />
          </Grid>
          <Grid item>
            <XsButton
              type='submit'
              form='consent-form'
              label='request_form.consent_confirm_button'
              variant='contained'
              disabled={!consentValue}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </XsBaseDialog>
  );
}

export default observer(ConsentDialog);
